import React from 'react';
import { motion } from 'framer-motion';
import { BabyIcon, HeartIcon, MilkIcon, SparklesIcon } from 'lucide-react';
const audiences = [{
  icon: SparklesIcon,
  title: 'MAMÁS EMBARAZADAS',
  description: 'Para llegar al nacimiento con información simple, realista y aplicable desde la primera toma.',
  className: 'bg-[#f5d5ce]'
}, {
  icon: BabyIcon,
  title: 'BEBÉS RECIÉN NACIDOS',
  description: 'Para entender el agarre, las señales de hambre y los primeros días sin quedarse sola con las dudas.',
  className: 'bg-brand-cream-light'
}, {
  icon: MilkIcon,
  title: 'LACTANCIA EN MARCHA',
  description: 'Para atravesar dolor, grietas, brotes, extracción o dudas sobre producción con un plan concreto.',
  className: 'bg-[#d4ddca]'
}, {
  icon: HeartIcon,
  title: 'PAPÁS Y FAMILIAS',
  description: 'Para acompañar a la mamá con respeto, información útil y decisiones que cuiden el vínculo.',
  className: 'bg-[#fff8e7]'
}];
export function WhoIsItFor() {
  return <section className="bg-brand-cream-light px-4 py-16 md:py-20" data-id="element-344" data-mp="1r4opn3qdcc4m">
      <div className="mx-auto max-w-6xl" data-id="element-345" data-mp="1v5idxy7q3sy1">
        <div className="mx-auto mb-10 max-w-3xl text-center" data-id="element-346" data-mp="1v47bc1q0kr8i">
          <p className="text-sm font-bold tracking-[0.14em] text-brand-accent uppercase" data-id="element-347" data-mp="1hedlbg2rw0x7">Acompañamiento real</p>
          <h2 className="mt-3 font-serif text-4xl text-brand-darker md:text-5xl" data-id="element-348" data-mp="1mbnacum92aki">¿Para quién es S.O.S. Lactancia?</h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-349" data-mp="17e3au384h7lq">
          {audiences.map((audience, index) => {
          const Icon = audience.icon;
          return <motion.article key={audience.title} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className={`${audience.className} rounded-3xl p-7 text-center shadow-sm`} data-id="element-350" data-mp="ygarmnza5ft2" data-mpi={index}>
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-cream/75" data-id="element-351" data-mp="2vdox166dkg48">
                  <Icon className="h-7 w-7 text-brand-darker" aria-hidden="true" data-id="element-352" data-mp="2raip7u3m6gvn" />
                </div>
                <h3 className="mt-5 text-base font-bold tracking-wide text-brand-darker" data-id="element-353" data-mp="2mda69ran68tc">{audience.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-darker/75" data-id="element-354" data-mp="2heywtho9e0bn">{audience.description}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}